<template>
    <div class="series-container">
        <ModuleTitle :caption="service.caption" :text="service.desc"></ModuleTitle>
        <List :items="service.items"></List>
    </div>
</template>

<script>
    import ModuleTitle from '../../common/ModuleTitle'
    import List from './List'

    export default {
        name: 'ServiceList',
        props: {
            service: Object,
        },
        components: {
            ModuleTitle,
            List
        },
        methods: {
            // goToPage(slug) {
            //     this.$router.push({
            //         path: 'series/' + slug
            //     })
            // }
        },
    }
</script>

<style lang="less" scoped>
    @import "../../../assets/style/var";

    .en {
        .series-container /deep/ .title {

            .module-title {
                font-size: 26px !important;
            }

            .module-sub-title {
                margin-top: 15px !important;
            }
        }
    }

    .btn {
        margin-top: 90px;
    }

    .series-container /deep/ .title {

        .module-title {
            font-size: 28px !important;
            line-height: 54px !important;
            font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
        }

        .module-sub-title {
            margin-top: 15px !important;
        }
    }

</style>
